module.exports = __webpack_public_path__ + "img/pig.8b71ce95.svg";